<template>
    <!--弹窗-->
    <el-dialog
        width="640px"
        title="选择忽略原因"
        :visible.sync="visible"
        :before-close="handleClose"
        append-to-body
    >

        <el-form ref="formData" label-width="100px">

            <el-form-item label="忽略原因：" class="query-form-item">
                <el-select v-model="disregarded_reason" placeholder="请选择">
                    <el-option label="同款已分析" value="同款已分析"></el-option>
                    <el-option label="找不到同款" value="找不到同款"></el-option>
                    <el-option label="利润不符" value="利润不符"></el-option>
                </el-select>
            </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose" type="primary" size="mini">取 消</el-button>
            <el-button @click="handleClose(true)" type="success" size="mini">确 定</el-button>
        </span>

    </el-dialog>
</template>
<script>

    export default {
        data() {
            return {
                disregarded_reason: null,
                visible: false,
                formData: {},
            }
        },
        methods: {
            openModal(data) {
                const tempData = JSON.parse(JSON.stringify(data))
                this.formData = tempData
                this.disregarded_reason = tempData.disregarded_reason
                this.visible = true
            },
            // 关闭弹窗
            handleClose(flag = false) {
                if (flag == true && this.disregarded_reason == null) {
                    this.$message.error('请选择忽略原因')
                    return
                }
                this.visible = false
                this.$emit('close-callback', {flag: flag == true, disregarded_reason: this.disregarded_reason, id: this.formData.id})
                this.disregarded_reason = null
            }
        }
    }
</script>
<style type="text/scss" lang="scss">
    .wrapBox {
        width: 600px;
        margin-top: 10px;

        .bottomBox {
            margin-top: 17px;
            display: flex;
            justify-content: center;
        }
    }

    .download {
        display: flex;
        justify-content: center;
    }

    .top {
        margin: 0px auto 20px;
        width: 60%;
        display: flex;
        justify-content: space-between;
    }
</style>

